// This file contains reusable strings that are used throughout the app.

const noFilterMessage = "No filter selected";

export { noFilterMessage };
